import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import classNames from 'classnames';
import AlgoliaResultsCount from 'components/consumer/ProductListingPage/components/AlgoliaResultsCount';
const ProductSearchCount = t0 => {
  const $ = _c(10);
  const {
    title,
    indexClick,
    selectedOption,
    id
  } = t0;
  const isSelected = selectedOption === id;
  let t1;
  if ($[0] !== isSelected) {
    t1 = classNames("w-full bg-white text-center lg:text-left", {
      "font-bold": isSelected
    });
    $[0] = isSelected;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== indexClick || $[3] !== title) {
    t2 = () => {
      indexClick(title.toLowerCase());
    };
    $[2] = indexClick;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AlgoliaResultsCount prefix=" (" suffix=")" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== title) {
    t4 = <div className="px-0 py-1.5 max-[767px]:p-0 hover:text-brand"><button type="button" className={t1} onClick={t2}>{title}{t3}</button></div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default ProductSearchCount;